import React, { useCallback, useEffect, useState, useRef } from "react";
import RichTextEditor from "../../components/richTextEditor/RichTextEditor";
import userService from "../../store/services/user.service";
import { generalActions } from "../../store/actions";
import { useDispatch } from "react-redux";
import { debounce } from 'lodash';

import "./MakeSure.scss";
import { AttachementRefType } from "../../store/services/attachments.service";

const MakeSure = (props) => {
  const { } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [notes, setNotes] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));
  const currentUserId = user.id;
  const dispatch = useDispatch();
  const notesdebounced = useRef(debounce((value) => handleUpdateNotes(value), 1000));

  const handleUpdateNotes = (value) => {
    userService.updateUserNotes({ notes: value });
  };

  const handleNotesChanged = useCallback((value) => {
    if (!isLoading && notes !== value) {
      setNotes(value);
      notesdebounced.current(value);
    }
  }, []);

  useEffect(() => {
    setIsLoading(true);
    userService.getUserNotes().then((data) => {
      setNotes(data)
    })
      .catch(() => {
        dispatch(
          generalActions.showToast({
            title: "Something went wrong. Please try again later.",
            type: "error",
          })
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (

    <div className="makeSureContainer">
      <div className="wrapper">
        <h4 className="mb-4">Make Sure</h4>
        <div className="textcontainer">
          <div className="customCard">
            <div>
              <RichTextEditor
                mode="advanced"
                content={notes}
                onChange={(val) => { handleNotesChanged(val) }}
                fileUploadParams={{ enabled: true, refType: AttachementRefType.MakeSure, refId: currentUserId }}
                loading={isLoading} />
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default MakeSure;